import Repository from "../../repository";

export default {
    GetListTreeStatus: (payload) => Repository.post(`/api/Status/GetListTreeStatus`, payload),
}
